import axios from 'axios';
import {
  AGENT_API_URL,
  API_URL,
  errNetworkCodes,
  localseoSignup,
  localSeoSignupSource
} from 'src/common/config/TextMessage';
import { getCookie, logoutFromApp } from './FunctionHelper';
// Global flag to avoid multiple logout triggers
let isSessionExpiredHandled = false;
const commonEndPointV1 = 'api/v2/';
const commonEndPointV2 = 'api/v2/';
const baseRoutes = {
  payment: 'payment',
  user: 'user',
  sites: 'sites',
  subPages: 'sub-pages',
  scan: 'scan',
  auditScan: 'audit-scan',
  keywordResearch: 'keyword-research',
  competitorAnalysis: 'competitor-analysis',
  openAI: 'open-ai',
  lead: 'lead',
  addon: 'addon',
  member: 'member',
  slots: 'slots',
  invitation: 'invitation',
  searchCredit: 'search-credit',
  keywordTracking: 'keyword-tracking',
  keywordList: 'keyword-list',
  backlinks: 'backlinks',
  localSeo: 'local-seo',
  mapRank: 'map-rank',
  open: 'open',
  aiVisibility: 'ai-visibility',
  citationBuilder: 'citation-campaign'
};

export class API {
  static siteSelection(
    siteSelection: string,
    post: string,
    undefined: undefined,
    payload: any,
    arg4: (response: any) => void
  ) {
    throw new Error('Method not implemented.');
  }

  static agentURLs = [
    'agents/keyword-intelligence'
  ]

  static EndPoint = {
    getHtmlFromUrl: `${commonEndPointV1}${baseRoutes?.user}/getHtml`,
    allPlan: `${commonEndPointV1}${baseRoutes?.payment}/plan`,
    login: `${commonEndPointV1}${baseRoutes?.user}/auth/login`,
    registration: `${commonEndPointV1}${baseRoutes?.user}/auth/create`,
    forgetPassword: `${commonEndPointV1}${baseRoutes?.user}/auth/forgot-password`,
    resetPassword: `${commonEndPointV1}${baseRoutes?.user}/auth/reset-password`,
    disconnectSquareSpace: `${commonEndPointV1}${baseRoutes?.user}/auth/square-disconnect`,
    userUpdate: `${commonEndPointV1}${baseRoutes?.user}/update`,
    updatePricingVersion: `${commonEndPointV1}${baseRoutes?.user}/update-pricing-version`,
    addSites: `${commonEndPointV1}${baseRoutes?.sites}/addSite`,
    addSubPages: `${commonEndPointV1}${baseRoutes?.subPages}`,
    createScan: `${commonEndPointV1}${baseRoutes?.scan}`,
    updateSubpages: `${commonEndPointV1}${baseRoutes?.subPages}`,
    checkOut: `${commonEndPointV1}${baseRoutes?.payment}/check-out`,
    updateCustomer: `${commonEndPointV1}${baseRoutes?.payment}/customer/update`,
    updateScan: `${commonEndPointV1}${baseRoutes?.user}/update-scan`,
    buyAddon: `${commonEndPointV1}${baseRoutes?.payment}/buy-addon`,
    addAddon: `${commonEndPointV1}${baseRoutes?.addon}`,
    editStripeCard: `${commonEndPointV1}${baseRoutes?.payment}/card-update`,
    subscriptionDetailsStripe: `${commonEndPointV1}${baseRoutes?.payment}/subscription-details`,
    optimizeScanChecks: `${commonEndPointV2}${baseRoutes?.scan}/individual-scan`,
    getAddon: `${commonEndPointV1}${baseRoutes?.payment}/addon`,
    getAddonMongo: `${commonEndPointV1}${baseRoutes?.addon}/get`,
    // getAllUserAddons: `${commonEndPointV1}addon/all',
    upgradeDowngradePlan: `${commonEndPointV1}${baseRoutes?.payment}/upgrade-downgrade`,
    openOptimize: `${commonEndPointV1}open/optimize`,
    searchDetails: `${commonEndPointV1}${baseRoutes?.user}/search-detail`,
    changePassword: `${commonEndPointV1}${baseRoutes?.user}/auth/change-password`,
    cancelSubscription: `${commonEndPointV1}${baseRoutes?.payment}/cancel-subscription`,
    v2UserDetails: `${commonEndPointV2}${baseRoutes?.user}/details`,
    v2SiteDetails: `${commonEndPointV2}${baseRoutes?.sites}/getSites`,
    getAffiliateList: `${commonEndPointV1}${baseRoutes?.user}/get-affiliate-list`,
    checkScan: `${commonEndPointV1}${baseRoutes?.user}/check-scan`,
    googleAuthUrl: `${commonEndPointV1}${baseRoutes?.user}/auth/google`,
    getAuthToken: `${commonEndPointV1}${baseRoutes?.user}/auth/google/token`,
    getDomain: `${commonEndPointV1}${baseRoutes?.user}/get-domain`,
    removeSite: `${commonEndPointV1}${baseRoutes?.sites}`,
    getPreviousScan: `${commonEndPointV2}${baseRoutes?.sites}/getSitesScansDetail`,
    getInsight: `${commonEndPointV1}${baseRoutes?.user}/get-Insights`,
    getRecommended: `${commonEndPointV1}${baseRoutes?.user}/get-recommended`,
    getInsightGraph: `${commonEndPointV1}${baseRoutes?.user}/get-InsightsGraph`,
    blogDetailsWithAI: `${commonEndPointV1}${baseRoutes?.openAI}/generate-blog-details`,
    deleteScan: `${commonEndPointV1}${baseRoutes?.scan}/delete`,
    hireUs: `${commonEndPointV1}${baseRoutes?.user}/hire-us`,
    paymentGetInvoices: `${commonEndPointV1}${baseRoutes?.payment}/get-invoices`,
    squareAuth: `${commonEndPointV1}${baseRoutes?.user}/auth/square`,
    squareAuthToken: `${commonEndPointV1}${baseRoutes?.user}/auth/square-token`,
    squareConnect: `${commonEndPointV1}${baseRoutes?.user}/auth/square-connect`,
    siteAuditUrl: `${commonEndPointV2}${baseRoutes?.auditScan}/get-audit-url`,
    auditOptimize: `${commonEndPointV2}${baseRoutes?.auditScan}/audit-optimize`,
    getAuditSiteDetail: `${commonEndPointV2}${baseRoutes?.auditScan}/audit-sites-detail`,
    AuditSite: `${commonEndPointV2}${baseRoutes?.auditScan}/audit-sites`,
    AuditStatus: `${commonEndPointV2}${baseRoutes?.auditScan}/audit-status`,
    getIndividualScan: `${commonEndPointV2}${baseRoutes?.scan}/get-individual-scan`,
    addUpdateMonitoring: `${commonEndPointV2}${baseRoutes?.auditScan}/add-update-monitoring`,
    auditCheckersCount: `${commonEndPointV2}${baseRoutes?.auditScan}/audit-checkers-count`,
    deleteSubPages: `${commonEndPointV1}${baseRoutes?.subPages}/`,
    siteDetail: `${commonEndPointV2}${baseRoutes?.auditScan}/site-details`,
    getKeywordsCount: `${commonEndPointV2}${baseRoutes?.user}/get-keywords-count`,
    getMonthlyTraffic: `${commonEndPointV2}${baseRoutes?.user}/get-monthly-traffic`,
    generateSiteDetailPdf: `${commonEndPointV2}${baseRoutes?.auditScan}/generate-site-detail-pdf`,
    getScansByIssue: `${commonEndPointV2}${baseRoutes?.auditScan}/get-scans-by-issue`,
    stopAudit: `${commonEndPointV2}${baseRoutes?.auditScan}/stop-audit`,
    reAudit: `${commonEndPointV2}${baseRoutes?.auditScan}/re-audit`,
    getStripeSlot: `${commonEndPointV1}${baseRoutes?.payment}/get-stripeslot`,
    createMember: `${commonEndPointV2}${baseRoutes?.member}/createMember`,
    slotSubscriptionUpdate: `${commonEndPointV1}${baseRoutes?.payment}/buy-slot`,
    slotList: `${commonEndPointV2}${baseRoutes?.slots}/getAllSlots`,
    inviteUser: `${commonEndPointV2}${baseRoutes?.invitation}/inviteUser`,
    cancelInvitation: `${commonEndPointV2}${baseRoutes?.invitation}/deleteInvitation/`,
    resendInvitation: `${commonEndPointV2}${baseRoutes?.invitation}/resendInvitation`,
    deleteSlot: `${commonEndPointV2}${baseRoutes?.slots}/deleteSlot`,
    getAllUserAddons: `${commonEndPointV2}${baseRoutes?.slots}/get-admin-slots`,
    deleteMember: `${commonEndPointV2}${baseRoutes?.member}/deleteMember/`,
    removeMultiSites: `${commonEndPointV2}${baseRoutes?.sites}/remove-multi-sites`,
    getSkippedUrls: `${commonEndPointV2}${baseRoutes?.auditScan}/get-skipped-urls`,
    getReAuditCount: `${commonEndPointV2}${baseRoutes?.auditScan}/re-audit-restrictions`,
    getRecommendationKeys: `${commonEndPointV1}${baseRoutes?.user}/get-recommendation-keys`,
    generateBlogPost: `${commonEndPointV2}${baseRoutes?.openAI}/generate-blog-post`,
    createLeadForm: `${commonEndPointV2}${baseRoutes?.lead}/create-lead-form`,
    getLeadDetails: `${commonEndPointV2}${baseRoutes?.lead}/lead-details`,
    getLeadForm: `${commonEndPointV2}${baseRoutes?.lead}/lead-form/`,
    createLead: `${commonEndPointV2}${baseRoutes?.lead}/create-lead`,
    getUserLeadForm: `${commonEndPointV2}${baseRoutes?.lead}/lead-form-by-user-id`,
    deleteLead: `${commonEndPointV2}${baseRoutes?.lead}/delete-lead/`,
    indexedCheckUpdate: `${commonEndPointV2}${baseRoutes?.auditScan}/indexed-check-update`,
    getKeywordOverview: `${commonEndPointV2}${baseRoutes?.keywordResearch}/get-keyword-overview`,
    getRelatedKeywords: `${commonEndPointV2}${baseRoutes?.keywordResearch}/get-related-keywords`,
    getCompetitorDetails: `${commonEndPointV2}${baseRoutes?.competitorAnalysis}/get-competitor-details`,
    topOrganicKeywords: `${commonEndPointV2}${baseRoutes?.competitorAnalysis}/top-organic-keywords`,
    getCreditDetails: `${commonEndPointV2}${baseRoutes?.searchCredit}/get-credit-details`,
    getSeoAcademy: `${commonEndPointV1}${baseRoutes?.user}/clicked-course`,
    logout: `${commonEndPointV1}${baseRoutes?.user}/auth/logout`,
    refreshToken: `${commonEndPointV1}${baseRoutes?.user}/refresh-token`,
    squareProductToken: `${commonEndPointV1}${baseRoutes?.user}/auth/square-product-token`,
    marketPlaceUsersCount: `${commonEndPointV2}open/market-place-users-count`,
    getGscGraphDetails: `${commonEndPointV2}${baseRoutes?.user}/get-gsc-graph-details`,
    getOrganicSearchTraffic: `${commonEndPointV2}${baseRoutes?.user}/get-organic-search-traffic`,
    createBriefPost: `${commonEndPointV2}${baseRoutes?.openAI}/blog-post-brief`,
    getBlogDetail: `${commonEndPointV2}${baseRoutes?.sites}/getBlogDetail`,
    getCardDetail: `${commonEndPointV1}${baseRoutes?.payment}/get-card-detail`,
    getPlanDetails: `${commonEndPointV1}${baseRoutes?.payment}/get-plan-details`,
    downgradeDeactivateOffers: `${commonEndPointV1}${baseRoutes?.payment}/downgrade-deactivate-offers`,
    resumePausedSubscription: `${commonEndPointV1}${baseRoutes?.payment}/resume-paused-subscription`,
    topRankingKeywordSuggestions: `${commonEndPointV2}${baseRoutes?.user}/top-ranking-keyword-suggestions`,
    keywordTracking: `${commonEndPointV2}${baseRoutes?.keywordTracking}`,
    getKeywordTracking: `${commonEndPointV2}${baseRoutes?.keywordTracking}`,
    deleteKeywordTracking: `${commonEndPointV2}${baseRoutes?.keywordTracking}`,
    updateMonitoringFrequency: `${commonEndPointV2}${baseRoutes?.keywordTracking}/update-monitoring-frequency`,
    competitorAnalysis: `${commonEndPointV2}${baseRoutes?.competitorAnalysis}/`,
    keywordResearch: `${commonEndPointV2}${baseRoutes?.keywordResearch}/`,
    keywordResearchTable: `${commonEndPointV2}${baseRoutes?.keywordResearch}/table/`,
    competitorAnalysisTable: `${commonEndPointV2}${baseRoutes?.competitorAnalysis}/table/`,
    getPreviousBlogPost: `${commonEndPointV2}${baseRoutes?.openAI}/get-previous-blog-post/`,
    getPreviousBlogPostIdeas: `${commonEndPointV2}${baseRoutes?.openAI}/get-previous-blog-post-ideas/`,
    disconnectGSC: `${commonEndPointV2}${baseRoutes?.user}/delete-gsc-token`,
    siteSelection: `${commonEndPointV2}${baseRoutes?.user}/select-default-token`,
    getKeywordPosition: `${commonEndPointV2}${baseRoutes?.keywordResearch}/get-keyword-position`,
    createUpdateKeywordList: `${commonEndPointV2}${baseRoutes?.keywordList}/create-update-keyword-list`,
    getKeywordList: `${commonEndPointV2}${baseRoutes?.keywordList}/get-keyword-list`,
    getKeywordListDetails: `${commonEndPointV2}${baseRoutes?.keywordList}/get-keyword-list-details`,
    deleteKeywordList: `${commonEndPointV2}${baseRoutes?.keywordList}/delete-keyword-list`,
    deleteKeywordListDetails: `${commonEndPointV2}${baseRoutes?.keywordList}/delete-keyword-list-details`,
    deleteMultipleItems: `${commonEndPointV1}${baseRoutes?.scan}/delete`,
    getBackLinksDetails: `${commonEndPointV2}${baseRoutes?.backlinks}/get-backlinks-details`,
    localSEOTag: `${commonEndPointV2}${baseRoutes?.user}/add-mailchimp-tag`,
    celebrationFlag: `${commonEndPointV2}${baseRoutes?.sites}/celebration-flag`,
    googleBusiness: `${commonEndPointV2}${baseRoutes?.localSeo}/auth/google-business`,
    googleBusinessToken: `${commonEndPointV2}${baseRoutes?.localSeo}/auth/google/business-token`,
    getLocations: `${commonEndPointV2}${baseRoutes?.localSeo}/get-locations`,
    locationInfo: `${commonEndPointV2}${baseRoutes?.localSeo}/location-info`,
    buyKeywordAddon: `${commonEndPointV1}${baseRoutes?.payment}/buy-keyword-addon`,
    locationMetrics: `${commonEndPointV2}${baseRoutes?.localSeo}/location-metrics`,
    gmpPostList: `${commonEndPointV2}${baseRoutes?.localSeo}/gmp-post-list`,
    createPost: `${commonEndPointV2}${baseRoutes?.localSeo}/create-post`,
    updatePost: `${commonEndPointV2}${baseRoutes?.localSeo}/update-post`,
    deletePost: `${commonEndPointV2}${baseRoutes?.localSeo}/delete-post`,
    gmpListById: `${commonEndPointV2}${baseRoutes?.localSeo}/gmp-list-by-id`,
    createUpdatePost: `${commonEndPointV2}${baseRoutes?.localSeo}/create-update-post`,
    reviewLists: `${commonEndPointV2}${baseRoutes?.localSeo}/review-lists`,
    updateReview: `${commonEndPointV2}${baseRoutes?.localSeo}/update-review`,
    createKeywordFolder: `${commonEndPointV2}keyword-folder`,
    reNameKeywordFolder: `${commonEndPointV2}keyword-folder`,
    keywordFolderAssign: `${commonEndPointV2}keyword-folder/assign`,
    deleteKeywordFolder: `${commonEndPointV2}keyword-folder`,
    updateBusinessDetails: `${commonEndPointV2}${baseRoutes?.localSeo}/update-business-details`,
    categoryLists: `${commonEndPointV2}${baseRoutes?.localSeo}/category-lists`,
    getSubPages: `${commonEndPointV2}${baseRoutes?.auditScan}/get-sub-pages`,
    localSeoTasks: `${commonEndPointV2}${baseRoutes?.localSeo}/local-seo-tasks`,
    googleAutoCompleteApi: `${commonEndPointV2}map-rank/autocomplete`,
    createMapRanker: `${commonEndPointV2}${baseRoutes?.mapRank}/create-map-ranker`,
    getReportDetail: `${commonEndPointV2}${baseRoutes?.mapRank}/get-report-detail`,
    getMapRankerHistory: `${commonEndPointV2}${baseRoutes?.mapRank}/get-map-ranker-history`,
    updateMapRankingMonitoring: `${commonEndPointV2}${baseRoutes?.mapRank}/update-map-ranking-monitoring`,
    updateMapRanker: `${commonEndPointV2}${baseRoutes?.mapRank}/update-map-ranker`,
    disconnectGoogleBusiness: `${commonEndPointV2}${baseRoutes?.localSeo}/disconnect-google-business`,
    validateCoupon: `${commonEndPointV2}${baseRoutes?.payment}/validate-coupon`,
    getBusinessCategory: `${commonEndPointV2}${baseRoutes?.mapRank}/get-business-category`,
    createMapRankerFromInfo: `${commonEndPointV2}${baseRoutes?.mapRank}/create-map-ranker-from-info`,
    generateMapRankPdf: `${commonEndPointV2}${baseRoutes?.mapRank}/generate-map-rank-pdf`,
    cancelAddon: `${commonEndPointV2}${baseRoutes?.payment}/cancel-addon`,
    getAddonDetail: `${commonEndPointV2}${baseRoutes?.payment}/get-addon-detail`,
    getLocationDetail: `${commonEndPointV2}${baseRoutes?.mapRank}/get-location-detail`,
    updateAiTask: `${commonEndPointV2}${baseRoutes?.auditScan}/update-ai-task`,
    localSeoPlan: `${commonEndPointV1}${baseRoutes?.payment}/local-seo-plan`,
    squareOrderToken: `${commonEndPointV1}${baseRoutes?.user}/auth/square-order-token`,
    createReviewWidget: `${commonEndPointV2}${baseRoutes?.localSeo}/create-update-review-widget`,
    getReviewWidget: `${commonEndPointV2}${baseRoutes?.open}/get-review-widget`,
    getAllReviewWidgets: `${commonEndPointV2}${baseRoutes?.localSeo}/get-all-review-widgets`,
    deleteReviewWidget: `${commonEndPointV2}${baseRoutes?.localSeo}/delete-review-widget`,
    getAllAuditedSites: `${commonEndPointV2}${baseRoutes?.sites}/scores`,
    updateSquarespaceConnection: `${commonEndPointV2}${baseRoutes?.localSeo}/update-squarespace-connection`,
    createAiVisibilityTasks: `${commonEndPointV2}${baseRoutes?.aiVisibility}/create-ai-visibility`,
    visibilityDetails: `${commonEndPointV2}${baseRoutes?.aiVisibility}/visibility-details`,
    promptResult: `${commonEndPointV2}${baseRoutes?.aiVisibility}/prompt-result`,
    visibilityGraph: `${commonEndPointV2}${baseRoutes?.aiVisibility}/visibility-graph`,
    sendSiteTransferInvitation: `${commonEndPointV2}${baseRoutes?.auditScan}/send-site-transfer-invitation`,
    siteTransferRespond: `${commonEndPointV2}${baseRoutes?.auditScan}/site-transfer-respond`,
    // For, Citation Builder
    getCampaignList: `${commonEndPointV2}${baseRoutes?.citationBuilder}/status`,
    scanCitations: `${commonEndPointV2}${baseRoutes?.citationBuilder}/citation-builder `, // This will create a new campaign
    draftACampaign: `${commonEndPointV2}${baseRoutes?.citationBuilder}/draft`, // This will draft (save) a campaign
    getACampaign: `${commonEndPointV2}${baseRoutes?.citationBuilder}/lookup`, // This will get a campaign
    citationUpdateRequest: `${commonEndPointV2}${baseRoutes?.citationBuilder}/confirm`,
    createLocation: `${commonEndPointV2}${baseRoutes?.mapRank}/create-location`,
    citationProgress: `${commonEndPointV2}${baseRoutes?.citationBuilder}`,
    citationReport: `${commonEndPointV2}${baseRoutes?.citationBuilder}`,
    emailCitationReport: `${commonEndPointV2}${baseRoutes?.citationBuilder}/email-report`,
    getLocationByLocationId: (locationId: string) =>
      `${commonEndPointV2}${baseRoutes?.citationBuilder}/location/${locationId}`,
    buyAiAddon: `${commonEndPointV2}${baseRoutes?.aiVisibility}/buy-ai-addon`,
    disableAiVisibility: `${commonEndPointV2}${baseRoutes?.sites}/disable-ai-visibility`,
    cancelSiteTransfer: (invitationId: string) =>
      `${commonEndPointV2}${baseRoutes?.auditScan}/cancel-site-transfer-invitation?invitationId=${invitationId}`,
    getAiSummary: `${commonEndPointV2}${baseRoutes?.auditScan}/get-ai-summary`,
    reportConfiguration: `${commonEndPointV2}${baseRoutes?.auditScan}/report-configuration`,
    getReportConfiguration: `${commonEndPointV2}${baseRoutes?.auditScan}/report-configuration`,
    getReportData: `${commonEndPointV2}${baseRoutes?.open}/get-report-data`,
    getLocalSeoReportData: `${commonEndPointV2}${baseRoutes?.open}/${baseRoutes?.localSeo}/get-report-data`,

    // Orbit AI
    getKeywordsAssistance4Site: (userId: string, siteId: string) => `${commonEndPointV2}agents/keyword-intelligence?userId=${userId}&siteId=${siteId}`,
    runKeywordIntelligence: `${commonEndPointV2}agents/keyword-intelligence/run`,

    getContentStrategy: (userId: string, siteId: string, pagination?: any) => {
      let url = `${commonEndPointV2}agents/content-strategy?userId=${userId}&siteId=${siteId}`;
      if (pagination) {
        Object.entries(pagination).forEach(([k, v]) => {
          if (v !== undefined && v !== null) {
            url += `&${k}=${v}`;
          }
        });
      }
      return url;
    },
    runContentStrategy: `${commonEndPointV2}agents/content-strategy/run`,
    generatePagePlan: (opportunityId: string, siteId: string, regenerate?: boolean) =>
      `${commonEndPointV2}agents/content-strategy/opportunities/${opportunityId}/generate-page-plan?siteId=${siteId}${regenerate ? '&regenerate=true' : ''}`,
    addOpportunityToPlan: (opportunityId: string, siteId: string) =>
      `${commonEndPointV2}agents/content-strategy/opportunities/${opportunityId}/plan?siteId=${siteId}`,
    ignoreOpportunity: (opportunityId: string, siteId: string) =>
      `${commonEndPointV2}agents/content-strategy/opportunities/${opportunityId}?siteId=${siteId}`,
    generateBlogFromClusterBlueprint: (blueprintId: string) =>
      `${commonEndPointV2}agents/content-strategy/blueprints/${blueprintId}/generate-blog`,
    generateClusterBlueprints: (clusterId: string, siteId?: string) =>
      `${commonEndPointV2}agents/content-strategy/clusters/${clusterId}/generate-blueprints${siteId ? `?siteId=${siteId}` : ''}`,
    generateTopicBlueprint: (clusterId: string, topicIndex: number, siteId?: string) =>
      `${commonEndPointV2}agents/content-strategy/clusters/${clusterId}/topics/${topicIndex}/generate-blueprint${siteId ? `?siteId=${siteId}` : ''}`,
    ignoreCluster: (clusterId: string, siteId?: string) =>
      `${commonEndPointV2}agents/content-strategy/clusters/${clusterId}${siteId ? `?siteId=${siteId}` : ''}`,
    ignoreImprovement: (improvementId: string, siteId?: string) =>
      `${commonEndPointV2}agents/content-strategy/improvements/${improvementId}${siteId ? `?siteId=${siteId}` : ''}`,
    getContentPlan: (siteId: string, page = 1, limit = 20) =>
      `${commonEndPointV2}content-plan?siteId=${siteId}&page=${page}&limit=${limit}`,

    getBlogBlueprints: (userId: string, siteId: string) => `${commonEndPointV2}agents/blog-generation?userId=${userId}&siteId=${siteId}&mode=blueprints`,
    createBlogPostBlueprints: `${commonEndPointV2}agents/blog-generation/blueprints`,
    getGeneratedBlog: (userId: string, siteId: string) => `${commonEndPointV2}agents/blog-generation?userId=${userId}&siteId=${siteId}&mode=blog&limit=10`,
    getGeneratedBlogByBlueprintId: (blueprintId: string) => `${commonEndPointV2}agents/blog-generation/blueprints/${blueprintId}/blog`,
    generateBlog: `${commonEndPointV2}agents/blog-generation/run`,

    getLocalSEOAgentReport: (userId: string, siteId: string, accountId: string, locationId: string) => `${commonEndPointV2}agents/local-seo?userId=${userId}&siteId=${siteId}&accountId=${accountId}&locationId=${locationId}`,
    runLocalSEOAgent: `${commonEndPointV2}agents/local-seo/run`,

    updateReviewAutomationSettings: `${commonEndPointV2}review-automation/settings`,
    getReviewAutomationSettings: (accountId: string, locationId: string, siteId?: string) => `${commonEndPointV2}review-automation/${accountId}/${locationId}/${siteId ? `${siteId}/` : ''}settings`,
    getReviewAutomationDashboard: (accountId: string, locationId: string, siteId?: string) => `${commonEndPointV2}review-automation/${accountId}/${locationId}/${siteId ? `${siteId}/` : ''}dashboard`,
    postReviewAutomationResponse: (responseId: string) => `${commonEndPointV2}review-automation/response/${responseId}`,
    getUserAgentDetails: (siteId: string) => `${commonEndPointV2}user/agents/${siteId}`,
    updateUserAgents: `${commonEndPointV2}user/agents`,
    getAgentsStatus: (siteId: string) => `${commonEndPointV2}agents/status?siteId=${siteId}`,
    updateLocalSEOBusinessDetails: `${commonEndPointV2}${baseRoutes?.localSeo}/update-business-details`,
    buyOrbitAIAddon: `${commonEndPointV2}agents/addon/buy`,

    // MCP
    mcpConnectorInfo: `${commonEndPointV2}mcp/connector-info`
  };

  static Method = {
    get: 'GET',
    post: 'POST',
    patch: 'PATCH',
    delete: 'DELETE',
    put: 'PUT'
  };

  //old code
  //static axiosCall(
  //  endpoint,
  //  type,
  //  params,
  //  payload,
  //  onCompletion,
  //  cancelToken: any = {}
  //) {
  //  let tokenStr = getCookie('RoughWaterUserLogging');
  //  var url = '';
  //  url = API_URL + '/' + endpoint + (params ? '' : '');
  //  axios(url, {
  //    method: type,
  //    withCredentials: false,
  //    data: payload,
  //    headers: { Authorization: `Bearer ${tokenStr}` },
  //    cancelToken: cancelToken.cancelToken
  //  })
  //    .then((res) => {
  //      onCompletion(res);
  //    })
  //    .catch((error) => {
  //      if (
  //        (error?.response?.status === 502 ||
  //          errNetworkCodes.includes(error?.code)) &&
  //        primaryEndpoint.includes(endpoint)
  //      ) {
  //        if (window.location.pathname !== paths.statusCheck) {
  //          window.location.reload(); // This will refresh the page
  //          localStorageMethod('set', 'api_down', 'true');
  //          //window.location.href = paths.statusCheck;
  //        }
  //      }
  //      // Original code
  //      onCompletion(error?.response);
  //      // Session Management logic do not remove this code
  //      // if (
  //      //   error?.response?.status === 401 &&
  //      //   endpoint !== this.EndPoint.login &&
  //      //   endpoint !== this.EndPoint.logout
  //      // ) {
  //      //   API.handleSessionExpired();
  //      // } else {
  //      //   onCompletion(error.response);
  //      // }
  //    });
  //}

  // Working Old code
  //static axiosCall(
  //  endpoint,
  //  type,
  //  params,
  //  payload,
  //  onCompletion,
  //  cancelToken: any = {}
  //) {
  //  let tokenStr = getCookie('RoughWaterUserLogging');
  //  const url = API_URL + '/' + endpoint + (params ? '' : '');
  //  const maxRetries = 3;
  //  let attempts = 0;

  //  const failedRequests = new Map(); // Track failed API calls

  //  const makeRequest = async () => {
  //    try {
  //      const response = await axios(url, {
  //        method: type,
  //        withCredentials: false,
  //        data: payload,
  //        headers: { Authorization: `Bearer ${tokenStr}` },
  //        cancelToken: cancelToken.cancelToken
  //      });
  //      onCompletion(response);
  //    } catch (error) {
  //      console.error(`Error occurred for ${endpoint}:`, error);

  //      // Retry logic for all errors
  //      attempts++;
  //      if (attempts < maxRetries) {
  //        console.warn(
  //          `Retrying request (${attempts}/${maxRetries}) for ${endpoint}...`
  //        );
  //        setTimeout(makeRequest, 2000 * attempts); // Exponential backoff
  //      } else {
  //        console.error(
  //          `Request failed after ${maxRetries} retries for ${endpoint}.`
  //        );
  //        failedRequests.set(endpoint, true);
  //        onCompletion(
  //          error?.response || {
  //            status: 500,
  //            data: { message: 'Request failed after multiple retries' }
  //          }
  //        );
  //      }
  //    }
  //  };

  //  if (!failedRequests.has(endpoint)) {
  //    makeRequest();
  //  } else {
  //    console.warn(`Skipping retry for ${endpoint} as it has already failed.`);
  //  }
  //}

  static axiosCall(
    endpoint,
    type,
    params,
    payload,
    onCompletion,
    cancelToken: any = {}
  ) {
    // 🚫 Hard block to avoid infinite calls when token expired
    if (isSessionExpiredHandled) {
      return onCompletion({
        status: 401,
        data: { message: 'Session expired' }
      });
    }

    let baseURL = API_URL;

    // if (API.agentURLs.some(u => endpoint.startsWith(u))) {
    //   baseURL = AGENT_API_URL;
    // }
    
    const url = baseURL + '/' + endpoint + (params ? '' : '');
    const maxRetries = 3;
    let attempts = 0;

    const retryableStatusCodes = [500, 502, 503, 504, 408];
    const failedRequests = new Map();

    const getLocalSeoCookie = getCookie(localseoSignup) ?? null;
    const isLocalSeo = getLocalSeoCookie === localSeoSignupSource;

    const noRetryEndpoints = [
      `${commonEndPointV2}${baseRoutes?.user}/get-gsc-graph-details`,
      `${commonEndPointV2}${baseRoutes?.user}/get-keywords-count`,
      `${commonEndPointV2}${baseRoutes?.user}/get-monthly-traffic`,
      `${commonEndPointV2}${baseRoutes?.user}/get-organic-search-traffic`,
      `${commonEndPointV1}${baseRoutes?.user}/get-affiliate-list`,
      `${commonEndPointV1}${baseRoutes?.user}/auth/google/token`,
      `${commonEndPointV2}${baseRoutes?.mapRank}/create-map-ranker`,
      `${commonEndPointV2}${baseRoutes?.localSeo}/get-locations`,
      `${commonEndPointV2}${baseRoutes?.mapRank}/get-report-detail`
    ];

    const restrictedApiCallsForLocalSeo = [];

    const isInvalidSiteIdentifier = (val: any) =>
      val === undefined ||
      val === null ||
      val === '' ||
      val === 'undefined' ||
      val === 'null' ||
      (typeof val === 'string' && val.trim() === '');

    const siteIdExemptEndpoints = [
      `${commonEndPointV1}${baseRoutes?.sites}/addSite`,
      `${commonEndPointV1}${baseRoutes?.user}/getHtml`,
      `${commonEndPointV2}${baseRoutes?.auditScan}/get-audit-url`,
      `${commonEndPointV2}${baseRoutes?.auditScan}/audit-urls`,
      `${commonEndPointV2}${baseRoutes?.sites}/getSites`,
      `${commonEndPointV2}${baseRoutes?.sites}/scores`
    ];

    const isExemptEndpoint = siteIdExemptEndpoints.some((exempt) =>
      endpoint.startsWith(exempt)
    );

    if (!isExemptEndpoint) {
      // 1. Check Body Payload
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        const siteKey = Object.keys(payload).find((k) =>
          ['siteId', 'site_Id', 'site_id', 'sites_id', 'sitesId'].includes(k)
        );
        if (siteKey && isInvalidSiteIdentifier(payload[siteKey])) {
          console.warn(
            `[API Guard] Blocked dispatch to "${endpoint}" due to invalid ${siteKey}:`,
            payload[siteKey]
          );
          onCompletion({
            status: 400,
            data: { message: `${siteKey} is required and cannot be empty.` }
          });
          return;
        }
      }

      // 2. Check URL Query Parameters & Path Segments
      const hasInvalidQueryParam =
        url.includes('siteId=undefined') ||
        url.includes('siteId=null') ||
        url.includes('site_id=undefined') ||
        url.includes('site_id=null') ||
        url.includes('sites_id=undefined') ||
        url.includes('sites_id=null') ||
        url.includes('siteId=&') ||
        url.endsWith('siteId=') ||
        url.includes('site_id=&') ||
        url.endsWith('site_id=') ||
        url.includes('sites_id=&') ||
        url.endsWith('sites_id=');

      const hasInvalidPathSegment =
        url.includes('/undefined/') ||
        url.endsWith('/undefined') ||
        url.includes('/null/') ||
        url.endsWith('/null');

      if (hasInvalidQueryParam || hasInvalidPathSegment) {
        console.warn(
          `[API Guard] Blocked dispatch to "${endpoint}" due to invalid URL site identifier in:`,
          url
        );
        onCompletion({
          status: 400,
          data: {
            message: 'Site identifier in URL is required and cannot be empty.'
          }
        });
        return;
      }
    }

    const makeRequest = async () => {
      try {
        const isOpenEndpoint = new RegExp(
          `^${commonEndPointV1}${baseRoutes?.open}(\\/|$)`
        ).test(endpoint);

        const response = await axios(url, {
          method: type,
          withCredentials: !isOpenEndpoint,
          data: payload,
          cancelToken: cancelToken.cancelToken,
          headers: {
            'X-Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          ...(endpoint ===
          `${commonEndPointV2}${baseRoutes?.mapRank}/generate-map-rank-pdf`
            ? { responseType: 'blob' }
            : {})
        });

        onCompletion(response);
      } catch (error) {
        const status = error?.response?.status;

        /** --------------------------
         *  🚫 STOP RETRY ON 401
         *  Trigger logout ONLY ONCE
         * ---------------------------*/
        if (
          status === 401 &&
          endpoint !== this.EndPoint.login &&
          endpoint !== this.EndPoint.logout
        ) {
          if (!isSessionExpiredHandled) {
            isSessionExpiredHandled = true;

            // BLOCK all requests instantly
            axios.defaults.adapter = () => {
              return Promise.reject({
                message: 'Session expired - request blocked'
              });
            };

            API.handleSessionExpired();
          }
          return;
        }

        // Skip retry if endpoint is marked as no-retry
        if (noRetryEndpoints.includes(endpoint)) {
          onCompletion(
            error?.response || {
              status: 500,
              data: { message: error?.message || 'An unexpected error occurred' }
            }
          );
          return;
        }

        // Retry logic (network/server errors)
        if (
          retryableStatusCodes.includes(status) ||
          errNetworkCodes.includes(error?.code) ||
          error?.message?.includes('blocked') ||
          error?.code === 'ERR_NETWORK'
        ) {
          attempts++;

          if (attempts < maxRetries) {
            setTimeout(makeRequest, 2000 * attempts); // exponential backoff
          } else {
            failedRequests.set(endpoint, true);
            onCompletion(
              error?.response || {
                status: 502,
                data: { message: 'Request failed after multiple retries' }
              }
            );
          }
        } else {
          onCompletion(
            error?.response || {
              status: 500,
              data: { message: error?.message || 'An unexpected error occurred' }
            }
          );
        }
      }
    };

    // Guard: skip API if Local SEO user and endpoint restricted
    if (isLocalSeo && restrictedApiCallsForLocalSeo.includes(endpoint)) {
      onCompletion({
        status: 403,
        data: { message: `This API is restricted for Local SEO users` }
      });
      return; //  Don't go into makeRequest()
    }

    if (!failedRequests.has(endpoint)) {
      makeRequest();
    } else {
      console.warn(`Skipping retry for ${endpoint} - already failed earlier.`);
    }
  }

  static getMCPConnectorInfo(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static handleSessionExpired() {
    logoutFromApp();

    setTimeout(() => {
      // Use assign() to avoid React re-render retry cascade
      window.location.assign('/');
    }, 50);
  }

  static sendEmail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getCouponDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addPayment(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static subscriptionCancel(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static subscriptionDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getPlanPrice(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static subscriptionUpdate(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static planOriginalPrice(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateCard(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getHtmlFromUrl(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static planChange(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static login(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static create(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static checkValidToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static userRegistration(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getUserDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static forgetPassword(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static resetPassword(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addSites(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static userUpdate(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updatePricingVersion(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addSubPages(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateSubpages(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static checkOut(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateCustomer(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static allPlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static buyAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static editStripeCard(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static subscriptionDetailsStripe(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static optimizeScanChecks(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAddonMongo(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAllUserAddons(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static upgradeDowngradePlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static openOptimize(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static searchDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static changePassword(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static cancelSubscription(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static v2getUserDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static v2getSiteDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAffiliateList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static checkScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static squareAuth(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static squareAuthToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static googleAuthentication(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAuthToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getDomain(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static removeSite(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getPreviousScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getInsight(
    endPoint,
    method,
    params,
    payload,
    onCompletion,
    cancelToken
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion, cancelToken);
  }

  static getRecommended(
    endPoint,
    method,
    params,
    payload,
    onCompletion,
    cancelToken
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion, cancelToken);
  }

  static getInsightGraph(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getBlogDetailsWithAI(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getHireUs(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static paymentGetInvoices(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static squareConnect(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static siteAuditUrl(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static auditOptimize(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAuditSiteDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static AuditSite(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static AuditStatus(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getIndividualScan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addUpdateMonitoring(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static auditCheckersCount(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteSubPages(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static siteDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordsCount(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getMonthlyTraffic(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateSiteDetailPdf(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static stopAudit(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static reAudit(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getScansByIssue(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getStripeSlots(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static buySlot(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createMember(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static slotSubscriptionUpdate(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static slotList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static inviteUser(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static cancelInvitation(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static resendInvitation(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteSlot(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteMember(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static removeMultiSites(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getSkippedUrls(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReAuditCount(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getRecommendationKeys(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateBlogPost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createLeadForm(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLeadDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLeadForm(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createLead(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getUserLeadForm(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteLead(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static indexedCheckUpdate(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordOverview(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getRelatedKeywords(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getCompetitorDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static topOrganicKeywords(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getCreditDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getSeoAcademy(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static logout(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static refreshToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static squareProductToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static marketPlaceUsersCount(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getGscGraphDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getOrganicSearchTraffic(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createBriefPost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getBlogDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getCardDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getPlanDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static downgradeDeactivateOffers(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static resumePausedSubscription(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static topRankingKeywordSuggestions(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static competitorAnalysis(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static keywordResearchTable(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static competitorAnalysisTable(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static keywordTracking(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordTracking(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteKeywordTracking(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static keywordResearch(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getPreviousBlogPost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getPreviousBlogPostIdeas(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateMonitoringFrequency(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static disconnectGSC(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static siteSelectionAPIHandler(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordPosition(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createUpdateKeywordList(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getKeywordListDetails(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteKeywordList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteKeywordListDetails(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteMultipleItems(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getBackLinksDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addLocalSEOTag(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static celebrationFlag(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static googleBusiness(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static googleBusinessToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLocations(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static locationInfo(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static buyKeywordAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static locationMetrics(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static gmpPostList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createPost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updatePost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deletePost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static gmpListById(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createUpdatePost(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static reviewLists(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateReview(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createKeywordFolder(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static reNameKeywordFolder(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static keywordFolderAssign(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteKeywordFolder(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateBusinessDetails(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static categoryLists(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getSubPages(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static localSeoTasks(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static googleAutoCompleteApi(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createMapRanker(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReportDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getMapRankerHistory(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateMapRankingMonitoring(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateMapRanker(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static disconnectGoogleBusiness(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static validateCoupon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getBusinessCategory(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createMapRankerFromInfo(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateMapRankPdf(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static cancelAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAddonDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static localSeoPlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLocationDetail(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateAiTask(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static squareOrderToken(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createReviewWidget(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReviewWidget(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAllReviewWidgets(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static deleteReviewWidget(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAllAuditedSites(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateSquarespaceConnection(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createAiVisibilityTasks(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static visibilityDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static promptResult(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static visibilityGraph(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static sendSiteTransferInvitation(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }
  // ===============================================
  // For, Citation Builder
  // ===============================================

  /**
   * This will get the list of campaigns for the Citation Builder feature.
   * @param {string} endPoint - The API endpoint for getting the list of campaigns.
   * @param {string} method - HTTP method to use (e.g. 'POST').
   * @param {object} params - Optional URL parameters for the request.
   * @param {object} payload - The request payload to send to the server.
   * @param {function} onCompletion - Callback function to execute after the request completes.
   */
  static getCampaignList(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  /**
   * This will create a new campaign for the Citation Builder feature.
   * @param {string} endPoint - The API endpoint for scanning citations.
   * @param {string} method - HTTP method to use (e.g. 'POST').
   * @param {object} params - Optional URL parameters for the request.
   * @param {object} payload - The request payload to send to the server.
   * @param {function} onCompletion - Callback function to execute after the request completes.
   */
  static scanCitations(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  /**
   * This will draft (save) a campaign for the Citation Builder feature.
   * @param {string} endPoint - The API endpoint for drafting a campaign.
   * @param {string} method - HTTP method to use (e.g. 'POST').
   * @param {object} params - Optional URL parameters for the request.
   * @param {object} payload - The request payload to send to the server.
   * @param {function} onCompletion - Callback function to execute after the request completes.
   */
  static draftACampaign(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  /**
   * This will get a details of a campaign.
   * @param {string} endPoint - The API endpoint for getting a details of a campaign.
   * @param {string} method - HTTP method to use (e.g. 'POST').
   * @param {object} params - Optional URL parameters for the request.
   * @param {object} payload - The request payload to send to the server.
   * @param {function} onCompletion - Callback function to execute after the request completes.
   */
  static getACampaign(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  /**
   * This will send a citation update request to BL (Bright Local).
   * @param {string} endPoint - The API endpoint for sending a citation update request to BL (Bright Local).
   * @param {string} method - HTTP method to use (e.g. 'POST').
   * @param {object} params - Optional URL parameters for the request.
   * @param {object} payload - The request payload to send to the server.
   * @param {function} onCompletion - Callback function to execute after the request completes.
   */
  static citationUpdateRequest(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static siteTransferRespond(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static disconnectSquareSpace(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createLocation(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static citationProgress(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static citationReport(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static emailCitationReport(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLocationByLocationId(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static buyAiAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static disableAiVisibility(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static cancelSiteTransfer(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAiSummary(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static reportConfiguration(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReportConfiguration(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReportData(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getLocalSeoReportData(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }


  static getKeywordsAssistance4Site(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static runKeywordIntelligence(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static runContentStrategy(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getContentStrategy(
    endPoint,
    method,
    params,
    payload,
    onCompletion
  ) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generatePagePlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static addOpportunityToPlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static ignoreOpportunity(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateBlogFromClusterBlueprint(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateClusterBlueprints(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateTopicBlueprint(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static ignoreCluster(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static ignoreImprovement(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getContentPlan(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getBlogBlueprints(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static createBlogPostBlueprints(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getGeneratedBlog(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getGeneratedBlogByBlueprintId(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static generateBlog(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }
  
  static getLocalSEOAgentReport(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }
  
  
  static runLocalSEOAgentReport(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateReviewAutomationSettings(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReviewAutomationSettings(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getReviewAutomationDashboard(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static postReviewAutomationResponse(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getUserAgentDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateUserAgents(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static getAgentsStatus(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static updateLocalSEOBusinessDetails(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

  static buyOrbitAIAddon(endPoint, method, params, payload, onCompletion) {
    API.axiosCall(endPoint, method, params, payload, onCompletion);
  }

}
